import PlaceHolderImageSrc from '@static/images/rush_rules_placeholder.png';
export const RUSH_RULES_PLACEHOLDER_IMAGE_SRC = PlaceHolderImageSrc;
